var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancelar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.58395 1.23059L2.58395 1.2306L7.99992 6.64684L13.416 1.2306C13.7902 0.856467 14.3952 0.856467 14.7693 1.2306C15.1436 1.60473 15.1436 2.20974 14.7693 2.58387L9.35332 8.0001L14.7693 13.4163C14.7693 13.4163 14.7693 13.4163 14.7693 13.4163C15.1436 13.7905 15.1436 14.3955 14.7693 14.7696L2.58395 1.23059ZM2.58395 1.23059C2.20966 0.856475 1.60485 0.856455 1.23072 1.23059C0.856425 1.60472 0.856425 2.20974 1.23072 2.58387L6.64668 8.0001M2.58395 1.23059L6.64668 8.0001M6.64668 8.0001L1.23072 13.4163C1.23072 13.4163 1.23072 13.4163 1.23072 13.4163C0.856433 13.7905 0.856428 14.3955 1.2307 14.7696C1.41717 14.9562 1.66241 15.05 1.90734 15.05C2.15227 15.05 2.39734 14.9562 2.58395 14.7696L7.99992 9.35337L13.416 14.7696C13.6027 14.9562 13.8477 15.05 14.0927 15.05C14.3376 15.05 14.5827 14.9562 14.7693 14.7696L6.64668 8.0001Z",
    fill: "#686868",
    stroke: "#686868",
    strokeWidth: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelar);
export default __webpack_public_path__ + "static/media/Cancelar.05eecc3b.svg";
export { ForwardRef as ReactComponent };